<template>
  <tr :class="{'disabled-row': !model.is_active}">
    <td>{{ model.name }}</td>
    <td>{{ model.email }}</td>
    <td>{{ model.country.name }}</td>
    <td>{{ model.role_name }}</td>
    <td>
      <div class="btn-group" v-if="model.is_active" role="group" aria-label="Basic example">
        <a @click="onSetInactiveClick" href="#" class="delete">
          <i class="cs-delete"></i>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import UserService from "@/services/UserService";

const userService = new UserService();

export default {
  name: "user-item",
  props: ["model"],
  methods: {
    onSetInactiveClick() {
      this.$dialog
        .confirm({
          title: i18n.app.common.warning,
          body: i18n.app.components.users.delete_text.replace(
            "{{userName}}",
            `<b>${this.model.name}</b>`
          )
        })
        .then(() => {
          userService.setInactive(this.model.id).then((updated_model) => {
            this.$emit("update-item-activity", this.model, updated_model);
          });
        });
    },
    onDeleteClick() {
      this.$dialog
        .confirm({
          title: i18n.app.common.warning,
          body: i18n.app.components.users.delete_text.replace(
            "{{userName}}",
            `<b>${this.model.name}</b>`
          )
        })
        .then(() => {
          userService.destroy(this.model.id).then(() => {
            this.$emit("delete", this.model);
          });
        });
    }
  }
};
</script>
